import { render, staticRenderFns } from "./RemoteWorkshop.vue?vue&type=template&id=61fbfb34&scoped=true&"
import script from "./RemoteWorkshop.vue?vue&type=script&lang=js&"
export * from "./RemoteWorkshop.vue?vue&type=script&lang=js&"
import style0 from "./RemoteWorkshop.vue?vue&type=style&index=0&id=61fbfb34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fbfb34",
  null
  
)

export default component.exports